import type { RefObject } from "react";

/**
 * Brings this Thread's current step into view, where a failed step is run again with its
 * inputs (OW-08). `currentStep` is the Thread view's own (`ThreadContext`), so a Thread in
 * another tab keeps its place (ADR-0039).
 */
export function showCurrentStep(currentStep: RefObject<HTMLElement | null>): void {
  currentStep.current?.scrollIntoView({ block: "start", behavior: "smooth" });
}
